import React, { forwardRef, Component } from 'react';
import { connect } from 'react-redux';
import {Button, Dropdown} from "react-bootstrap";
import { Form } from 'react-bootstrap';
import SVG from "react-inlinesvg";
import { sceneUpdateHeight} from '../../../../../../../actions/sceneActions'
import { GET_HEIGHT_WIDTH } from "../../../../../../../utils";
import { toAbsoluteUrl } from '../../_helpers';
import { FontAwesomeIcon } from '../../../../../../CommonComponents/AssetsHelper';

class HeightComponent extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }
    state = {
        value: null,
        beforeValue: null,
        height: 0, width: 0, label: "",
    }
    componentDidMount = async () => {
        const { cssStyle, position, layouts, mixContentType } = this.props;
        const customData = await GET_HEIGHT_WIDTH(cssStyle, position, layouts, mixContentType)
        if (customData && Object.keys(customData)) {
            const { height, width, label } = customData;
            this.setState({ beforeValue: height == 0 ? width : width == 0 ? height : ``, value: height == 0 ? width : width == 0 ? height : ``, height, width, label: label })
        }
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    onChange = event => {
        if(event.target.value>=0 && event.target.value<=100)this.setState({ value: event.target.value ? event.target.value : 0 });
    }
    handleClickOutside = e => {
        if (!this.myRef.current.contains(e.target)) {
            const { show } = this.state;
            this.setState({ show: false })
        }
    };
    onSubmit = event => {
        const { cssStyle, position, layouts, mixContentType, activeID } = this.props;
        const { value, height, width, label } = this.state;
        this.props.sceneUpdateHeight(cssStyle, position, layouts, mixContentType, activeID, { value, height, width, label })
        this.setState({ show: false })
    }
    componentWillReceiveProps(nextPorps) {
        const { cssStyle, position, layouts, mixContentType } = nextPorps;
        const customData = GET_HEIGHT_WIDTH(cssStyle, position, layouts, mixContentType)
        if (customData && Object.keys(customData)) {
            const { height, width, label } = customData;
            this.setState({ beforeValue: height == 0 ? width : width == 0 ? height : ``, value: height == 0 ? width : width == 0 ? height : ``, height, width, label: label })
        }

    }
    selectedLayoutPanel = forwardRef((props, ref) => {
        if(props['data-value'] != 100){
            return (
                <Button variant=''
                    ref={ref}
                    onClick={e => {
                        e.preventDefault();
                        const { show } = this.state;
                        this.setState({ show: !show })
                        props.onClick(e);
                    }}
                    id="kt_subheader_quick_actions-layout-he" className="activeZone f-between rounded-0 border-0">

                    <div className="me-2">
                        {props['data-label']} : {props['data-value']} %
                    </div>
                    <FontAwesomeIcon type={'regular'} icon={'angle-down'} iconClass={''} />
                </Button>
            );
        }else{
            return false
        }
    });
    render() {
        const { height, width, value, label, show, beforeValue } = this.state;
        return <Dropdown ref={this.myRef} className="dropdown-inline" drop="down" show={show}>
            <Dropdown.Toggle
                as={this.selectedLayoutPanel}
                id="dropdown-toggle-quick-actions-subheader-layout-height"
                data-target="#layout-height"
                data-height={height}
                data-width={width}
                data-value={beforeValue}
                data-label={label}
            />
            <Dropdown.Menu className="dropdown-menu dropdown-menu-right p-3" id="layout-height">
                <Form.Group controlId="formBasicEmail">
                    <Form.Label className="mb-2">{label} : </Form.Label>
                    <div className="f-center">
                        <Form.Control type="number" className="height_adjust form-control-sm me-2" min={1} max={99} maxLength={2} value={value} onChange={this.onChange} />
                        <Button variant='primary' className="py-2" onClick={this.onSubmit} >Save</Button>
                    </div>
                </Form.Group>
            </Dropdown.Menu>
        </Dropdown>
    }
}

const mapStateToProps = state => {
    return {
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {

        sceneUpdateHeight: (cssStyle, position, layouts, mixContentType, sceneID, currentChanges) => dispatch(sceneUpdateHeight(cssStyle, position, layouts, mixContentType, sceneID, currentChanges)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeightComponent);